// Client-side assertions. Same shape as the worker's primitive so the team uses one mental model.
// In production these throw; an ErrorBoundary up top catches and shows a recoverable state.

export class AssertionError extends Error {
  override readonly name = 'AssertionError';
  readonly context: Record<string, unknown>;
  constructor(message: string, context: Record<string, unknown> = {}) {
    super(message);
    this.context = context;
  }
}

export function assert(cond: unknown, message: string, ctx?: Record<string, unknown>): asserts cond {
  if (!cond) throw new AssertionError(message, ctx ?? {});
}

export function assertNum(v: unknown, name: string, opts?: { min?: number; max?: number }): asserts v is number {
  assert(typeof v === 'number' && Number.isFinite(v), `${name} must be a finite number`, { actual: typeof v });
  if (opts?.min !== undefined) assert(v >= opts.min, `${name} below minimum`, { v, min: opts.min });
  if (opts?.max !== undefined) assert(v <= opts.max, `${name} above maximum`, { v, max: opts.max });
}

export function assertString(v: unknown, name: string): asserts v is string {
  assert(typeof v === 'string' && v.length > 0, `${name} must be non-empty string`, { actual: typeof v });
}
